<template>
  <v-row justify="center">
    <v-dialog v-model="showDialog" persistent max-width="700">
      <v-card>
        <v-card-title class="headline custom-card-header">Add Staff
          <v-spacer></v-spacer>
          <v-btn color="white" icon @click="toggle"><v-icon>close</v-icon></v-btn>
        </v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" sm="12" md="12">
              <v-text-field
                label="Email"
                v-model="newUser.email">
              </v-text-field>

              <v-text-field
                label="First Name"
                v-model="newUser.firstName">
              </v-text-field>

              <v-text-field
                label="Last Name"
                v-model="newUser.lastName"
              ></v-text-field>

              <v-text-field
                label="Phone"
                v-model="newUser.phoneNumber"
              ></v-text-field>

              <v-text-field
                label="Password"
                :type="'password'"
                v-model="newUser.password"
              ></v-text-field>

              <v-select
                :items="roles"
                item-text="name"
                item-value="id"
                standard
                label="Role"
                v-model="newUser.role"
              ></v-select>
            </v-col>
          </v-row>
          <div v-if="disabled" class="text-center">
            Saving<br />
            <v-progress-circular
              indeterminate
              color="success"
              v-if="disabled"
            ></v-progress-circular>
          </div>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn block depressed color="accent" @click="createUser" :disabled="disabled">Add</v-btn>
          </v-card-actions>
        </v-container>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    showDialog: {
      type: Boolean,
      required: true
    },
    toggle: {
      type: Function,
      required: true
    }
  },
  data () {
    return {
      newUser: {
        email: null,
        password: null,
        role: null,
        firstName: null,
        lastName: null,
        phoneNumber: null,
        disabled: false,
      },
      disabled: false
    }
  },
  methods: {
    ...mapActions({
      create: 'user/createUser'
    }),
    async createUser () {
      this.disabled = true
      await this.create(this.newUser)
      if (!this.error) {
        this.toggle()
      }
      this.disabled = false
    }
  },
  computed: {
    ...mapGetters({
      roles: 'role/roles',
      error: 'user/error'
    })
  }
}
</script>
<style scoped>
    .custom-card-header {
        background-color: #00A5C5;
        color: white;
    }
</style>
